import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum';
import UserItem from './UserItem';
import UserSearchParams from './UserSearchParams';
import UserService from '../../../Services/userService';
import MassMessageItem from '../../../Domain/MassMessageItem';
import MassMessagePanelDescription from '../../Messages/MassMessagePanelDescription';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EditUserWindowDescription from './EditUserWindowDescription';
import EditRelatedUserWindowDescription from './EditRelatedUserWindowDescription';
import MassSupervisorEditWindowDescription from './MassSupervisorEditWindowDescription';
import SetTimesheetUserWindowDescription from './SetTimesheetUserWindowDescription';

class UserAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    UserItem.editFunction = (id, user, userList) => this.editFunction(id, user, userList);
    UserItem.clickOnTimesheetUserItemLink = this.showSetTimesheetUserWindow.bind(this);
    UserItem.clickOnEditRelatedUserLink = this.clickOnEditRelatedUserLink.bind(this);
    UserItem.clickOnAddNewRelatedUserLink = this.clickOnAddNewRelatedUserLink.bind(this);
    this.clickOnSendMessageButton = this.clickOnSendMessageButton.bind(this);
    UserItem.grantTimesheetExtendedEditPermission = this.grantTimesheetExtendedEditPermission.bind(this);

    this.state = {
      shownPanel: ShownPanelsEnum.Search,
      searchItem: new UserSearchParams(),
      orderBy: 'Id',
      orderDirection: 'Asc',
      selected: -1,
      selectedItem: null,
      shownOverWindow: ShownOverWindowsEnum.None,
      selectedRelatedUser: null,
      userList: [],
      allItemsInTheSearchSetAreSelected: false,
      window: null,
    };
    this.showPanel = this.showPanel.bind(this);
    this.changeOfItemListFunction = this.changeOfItemListFunction.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  clickOnEditRelatedUserLink(subItem, mainItem) {
    this.setState({
      selectedRelatedUser: subItem,
      shownPanel: ShownPanelsEnum.EditSubItem,
      selectedItem: mainItem,
    });
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  editFunction(id, user, userList) {
    this.setState({
      shownPanel: ShownPanelsEnum.EditMainItem,
      selectedItem: user,
    });
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  showSetTimesheetUserWindow(user) {
    this.setState({
      shownPanel: ShownPanelsEnum.UserSetTimesheetUser,
      selectedItem: user,
    });
  }

  clickOnAddNewRelatedUserLink(item) {
    this.setState({
      shownPanel: ShownPanelsEnum.AddNewSubItem,
      selectedItem: item,
    });
  }

  grantTimesheetExtendedEditPermission(user) {
    ErrorMessage.SetApprove(
      `You will grant extended timesheet edit permission for ${user.FirstName} ${user.LastName} for three days.`,
      () => this.clickOnGrantTimesheetExtendedEditPermissionButtonInPopup(user)
    );
  }

  clickOnGrantTimesheetExtendedEditPermissionButtonInPopup(user) {
    UserService.GrantTimesheetExtendedEditPermission(user)
      .then((result) => ErrorMessage.SetNotification('Permission has been granted.'))
      .catch((error) => ErrorMessage.SetErrorMessage('UA195'));
  }

  clickOnSaveInUserSetTimesheetUserWindow() {
    this.setState({
      shownOverWindow: ShownOverWindowsEnum.None,
      shownPanel: ShownPanelsEnum.None,
    });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem }, shownPanel: ShownPanelsEnum.None });
  }

  renderButtonsAndPanels() {
    return (
      <>
        <FigmaButtonRow
          buttons={[
            {
              iconName: 'fa-solid fa-plus-circle',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.showPanel(ShownPanelsEnum.AddNewItem),
              tooltip: 'New User',
              roleKey: 'useradmin_EditUser',
            },
            {
              iconName: 'fa-solid fa-users',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.showPanel(ShownPanelsEnum.MultiEdit),
              tooltip: 'Mass Supervisor Edit',
              roleKey: 'useradmin_EditUser',
            },
            {
              iconName: 'fa-regular fa-messages',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.clickOnSendMessageButton(),
              tooltip: 'In-App Mass Message',
              disabled: !this.IsAnyItemSelected(),
              roleKey: 'useradmin_EditUser',
            },
          ]}
        />
        {this.renderPanels()}
      </>
    );
  }

  renderPanels() {
    return (
      <div>
        {this.state.shownPanel === ShownPanelsEnum.EditMainItem && (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.getEditedMainUser()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={this.refresh}
            windowDescription={EditUserWindowDescription}
            errorCode={'UA164'}
          />
        )}
        {this.state.shownPanel === ShownPanelsEnum.EditSubItem && (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.getEditedSubUserItem()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={this.refresh}
            windowDescription={EditRelatedUserWindowDescription}
            errorCode={'UA174'}
          />
        )}
        {this.state.shownPanel === ShownPanelsEnum.AddNewItem && (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.getNewUserItem()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={this.refresh}
            windowDescription={EditUserWindowDescription}
            errorCode={'UA184'}
          />
        )}
        {this.state.shownPanel === ShownPanelsEnum.AddNewSubItem && (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.getNewSubUserItem()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={this.refresh}
            windowDescription={EditRelatedUserWindowDescription}
            errorCode={'UA194'}
          />
        )}
        {this.state.shownPanel === ShownPanelsEnum.MultiEdit && (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={{ OrinalSupervisorId: '', NewSupervisorId: '' }}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={this.refresh}
            windowDescription={MassSupervisorEditWindowDescription}
            errorCode={'UA204'}
          />
        )}
        {this.state.shownPanel === ShownPanelsEnum.UserSetTimesheetUser && (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.getItemForTimesheetUserSelect()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={this.refresh}
            windowDescription={SetTimesheetUserWindowDescription}
            errorCode={'UA214'}
          />
        )}
      </div>
    );
  }

  getEditedMainUser() {
    const editedItem = this.state.selectedItem;
    if (editedItem) {
      editedItem.IsNewUser = false;
    }

    return editedItem;
  }

  getItemForTimesheetUserSelect() {
    const selectedItemForTimesheetUserSelect = this.state.selectedItem;
    if (selectedItemForTimesheetUserSelect) {
      selectedItemForTimesheetUserSelect.RelatedUsers.forEach((user) => {
        if (user.isTimeSheetUser === true) {
          selectedItemForTimesheetUserSelect.TimesheetUserUserName = user.userName;
        }
      });
    }
    return selectedItemForTimesheetUserSelect;
  }

  getEditedSubUserItem() {
    const selectedItemForSubEdit = this.state.selectedRelatedUser;
    if (selectedItemForSubEdit) {
      selectedItemForSubEdit.IsNewUser = false;
      selectedItemForSubEdit.SelectedCaspianRoles = [];
      selectedItemForSubEdit.OfficeId = this.state.selectedRelatedUser.officeId;
      selectedItemForSubEdit.UserName = this.state.selectedRelatedUser.userName;
      selectedItemForSubEdit.UserId = this.state.selectedRelatedUser.userId;
    }
    return selectedItemForSubEdit;
  }

  getNewSubUserItem() {
    const selectedItemForNewSub = this.state.selectedItem;
    if (selectedItemForNewSub) {
      selectedItemForNewSub.IsNewUser = true;
      selectedItemForNewSub.SelectedCaspianRoles = [];
    }
    return selectedItemForNewSub;
  }

  getNewUserItem() {
    const newUserItem = new UserItem();
    newUserItem.IsActive = true;
    newUserItem.IsNewUser = true;
    newUserItem.NotificationsEnabled = true;
    newUserItem.NoTs = false;
    return newUserItem;
  }

  IsAnyItemSelected() {
    return this.state.userList.find((u) => u.Selected === true) !== undefined;
  }

  numberOfSelectedUsers() {
    return this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.userList.filter((u) => u.Selected === true).length;
  }

  getSelection() {
    return {
      allItemInTheSearchSetAreSelected: this.state.allItemsInTheSearchSetAreSelected,
      searchItem: this.state.searchItem,
      selectedIds: this.state.userList.filter((u) => u.Selected).map((f) => f.UserId),
      numberOfSelectedUsers: this.numberOfSelectedUsers(),
    };
  }

  clickOnSendMessageButton() {
    const popup = (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Create}
        editedItem={new MassMessageItem(this.getSelection())}
        windowDescription={MassMessagePanelDescription}
        clickOnCancel={() => this.setState({ window: null })}
        clickOnSave={() => this.setState({ window: null })}
        errorCode='MMW'
      />
    );
    this.setState({ window: popup });
  }

  changeOfItemListFunction(itemList, numberOfElementsInTheTable) {
    this.setState({ userList: itemList, numberOfElementsInTheTable });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={UserItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={UserService.GetUserListBySearching}
          convertDBItemsFunction={UserService.ConvertDBUser}
          searchItem={this.state.searchItem}
          orderDirection={this.state.orderDirection}
          orderBy={this.state.orderBy}
          showSearchStrip={true}
          searchParamsType={UserSearchParams}
          clickOnStartSearch={this.startSearch.bind(this)}
          itemList={this.state.userList}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          itemTypeName={'users'}
          changeOfItemListFunction={this.changeOfItemListFunction}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in ID, name or email...'
          errorCode='UA324'
        />
        {this.state.window}
      </div>
    );
  }
}

export default UserAdmin;
